import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

// Stores where M1+UHX bundling is off (UHX auto-add, cart add-on, special-price
// checkout, UHX-paired discounts); M1 ops campaigns still apply. GB is its own
// store but aliases to EU for variant IDs, so list GB — not EU.
export const M1_UHX_BUNDLING_DISABLED_STORES: ReadonlySet<ShopifyStore> =
  new Set([ShopifyStore.GB]);

export function isM1UhxBundlingEnabled(
  store?: ShopifyStore | null,
): boolean {
  return !!store && !M1_UHX_BUNDLING_DISABLED_STORES.has(store);
}
